'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const disableSelect = function () {
  let customStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    borderColor: '#e0e0e0',
    color: '#e0e0e0',
    cursor: 'not-allowed',
    ...customStyles
  };
};
const StyledSelect = styled__default["default"].select.withConfig({
  componentId: "sc-tqb596-0"
})(_ref => {
  let {
    s = {}
  } = _ref;
  return {
    width: s.width || '100%',
    minWidth: s.minWidth || '6.25rem',
    height: s.height || '2.5rem',
    borderStyle: s.borderStyle || 'solid',
    borderColor: s.borderColor || '#999',
    borderWidth: s.borderWidth || '0.0625rem',
    borderRadius: s.borderRadius || '0.125rem',
    cursor: s.cursor || 'auto',
    paddingLeft: s.paddingLeft || '0.75rem',
    paddingRight: s.paddingRight || '0.75rem',
    outlineWidth: s.outlineWidth || '0',
    fontSize: s.fontSize || '0.875rem',
    color: s.color || '#666'
  };
});
const SelectList = _ref2 => {
  let {
    className = '',
    s = {},
    value,
    defaultValue,
    disabled = false,
    onChange,
    onFocus,
    onBlur,
    children
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(StyledSelect, {
    className: className,
    s: disabled ? disableSelect(s) : s,
    defaultValue: value || defaultValue,
    disabled: disabled,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  }, children);
};

exports["default"] = SelectList;
exports.disableSelect = disableSelect;
